import React, { useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
const JiraIntegrationPopupAddInstances = props => {
  const [key, setKey] = useState("");
  const [url, setUrl] = useState("");
  const [error, setError] = useState(false);
  const [authError, setAuthError] = useState(false);
  const { t } = useTranslation()
  const connectToJira = () => {
    if (!allGood()) {
      setError(true);
      return;
    }
    setAuthError(false);
    axios
      .get(`${wbConfig.baseUrl}/integration/performJiraOAuth`, {
        params: {
          key,
          url
        }
      })
      .then(response => {
        if (response.data && response.data.redirect) {
          const params = `status=no,location=no,toolbar=no,menubar=no,width=400,height=400,\
            top=${window.top.outerHeight / 2 + window.top.screenY - 200},\
            left=${window.top.outerWidth / 2 + window.top.screenX - 200}`;
          const popup = window.open(response.data.redirect, "_blank", params);
          const timer = setInterval(() => {
            try {
              const href = popup.location.href;
              console.log('href2', href);
              if (href.indexOf("/user/profile/edit?do=mgInt") > 0) {
                popup.close();
                clearInterval(timer);
                props.updateParentState(url);
                props.closePopup(false);
              } else if (popup.location.href.indexOf("/goal/index") > 0) {
                popup.close();
                clearInterval(timer);
                props.updateParentState(url);
                props.closePopup(true);
              }
            } catch (e) {}
          }, 500);
        } else {
          setAuthError(true);
        }
      });
  };

  const allGood = () => {
    const trimmedUrl = url.trim();
    const trimmedKey = key.trim();
    if (
      trimmedUrl.length &&
      trimmedKey.length &&
      (trimmedUrl.toLowerCase().indexOf("http://") === 0 ||
       trimmedUrl.toLowerCase().indexOf("https://") === 0)
    ) {
      return true;
    } else return false;
  };

  return (
    <div className="login-jira-add-instances">
      <div className="login-jira-body">
        <div className="login-jira-details-header">
          {t('Configure')} {props.data.orgName} {`${t('as a consumer in Jira through Application Links')}:`}
        </div>
        <div className="login-jira-details">
          <div>
            <ol>
              <li>
                {
                  `${t('In JIRA, navigate to Settings (cog icon)')} > ${t('Products')} > ${t('Application links')}.`
                }
              </li>
              <li>
                {
                  `${t("In the field 'Enter the URL of the application you")} \
                            ${t("want to link', paste the following URL")} --`
                }
                <br />
                <code>{props.data.callBackUrl}</code>
                <br />
                {
                 `${t('and click Create new link.')} ${t("You’ll get a warning that ‘No response was received from the")} \
                            ${t('URL you entered’.')}  ${t('Ignore it and click Continue.')}`
                }
              </li>
              <li>
                {
                  `${t("On the first screen of the Link applications dialog, tick the 'Create incoming link'")} \
                            ${t('checkbox.')} ${t('Enter anything you want in the remaining fields on the screen.')}`
                }
              </li>
              <li>
                {
                  `${t('On the second screen of the Link applications dialog, enter the following values')}:`
                }
                <br />
                <b>{t('Consumer key')}</b>:{" "}
                <i>
                  {`${t('Your auth key.')} ${t('Can be any string you choose')} \
                            (e.g. ${props.data.orgName.toLowerCase()}_jira_integration); ${t('be sure to')} \
                            ${t('write it down for use below.')}`}
                </i>{" "}
                <br />
                <b>{t('Consumer name')}</b>: <i>{props.data.orgName.toLowerCase()}</i>
                <br />
                <b>{t('Public key')}</b>: {`${t('Copy and paste the public key below')}:`}
              </li>
              <pre>{props.data.jiraPublicKey}</pre>
              <li>
                {t('Click')} <b>{t('Continue')}</b> {t(`to complete the Jira setup, then proceed to the next step.`)}
              </li>
            </ol>
          </div>
          <div style={{'margin-bottom': "10px"}}>
            {`${t('WorkBoard will have offline read and write access to your Jira instance once connected.')} ${t('This will enable tracking of issue completion data and allowing syncing of data.')}`}
          </div>
        </div>
        <div className="login-jira-details-header">
          {t('Requesting your access in Jira')}
        </div>
        <label htmlFor="key">
          {t('Consumer Key')}<span className="typefacetext">*</span>
          <br />
        </label>
        <input
          placeholder={`${props.data.orgName.toLowerCase()}_jira_integration`}
          className={!url.length && error ? "error" : ""}
          type="text"
          onChange={e => setKey(e.currentTarget.value)}
          value={key}
          name="key"
          id="jira_consumer_key"
        />
        <label htmlFor="url">
          {t('Base UR')}L<span className="typefacetext">*</span>
        </label>
        <input
          placeholder="https://example.atlassian.net/"
          className={!url.length && error ? "error" : ""}
          type="text"
          onChange={e => setUrl(e.currentTarget.value)}
          value={url}
          name="url"
          id="jira_app_url"
        />
        <span
          id="link-error"
          className={`login-jira-error-msg ${
            error ? "login-jira-error-msg-show" : ""
          }`}
        >
          {t('Please enter a valid link including http:// or https://')}
        </span>
      </div>
      <div className="login-jira-footer">
        <input
          type="button"
          value={t("Connect")}
          className="connect-button"
          onClick={connectToJira}
        />
        <span
          className={`login-jira-error-msg ${
            authError ? "login-jira-error-msg-show" : ""
          }`}
        >
          {
            `${t('Authorization failed - check your Jira public url')} \
                ${t('and consumer key.')}`
          }
        </span>
      </div>
    </div>
  );
};

export default JiraIntegrationPopupAddInstances;
